var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternDotsVertical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 112,
    viewBox: "0 0 104 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4755 111.174L47.4757 111.174L47.4753 111.16C47.433 109.649 48.6004 108.493 50.06 108.499C51.5223 108.505 52.6847 109.677 52.6785 111.14C52.6723 112.602 51.4986 113.768 50.0866 113.815C48.6278 113.805 47.4693 112.634 47.4755 111.174Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2962 108.394C66.7585 108.4 67.9209 109.572 67.9147 111.035C67.9085 112.497 66.7361 113.659 65.2738 113.653C63.8141 113.647 62.6489 112.477 62.5987 111.068C62.6617 109.538 63.8457 108.388 65.2962 108.394Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5318 108.289C81.9938 108.295 83.1605 109.469 83.2071 110.881C83.197 112.34 82.0262 113.498 80.5663 113.492C79.1043 113.486 77.9375 112.312 77.8909 110.9C77.9011 109.441 79.0719 108.283 80.5318 108.289Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.185 110.859L93.1851 110.845L93.1842 110.831C93.0946 109.395 94.2443 108.234 95.7126 108.24C97.1746 108.247 98.3412 109.42 98.3878 110.832C98.3777 112.291 97.2057 113.454 95.7961 113.5C94.3373 113.49 93.1788 112.319 93.185 110.859Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4204 96.447L47.4206 96.447L47.4202 96.4331C47.3779 94.922 48.5452 93.7654 50.0049 93.7716C51.4672 93.7778 52.6295 94.9501 52.6233 96.4124C52.6171 97.8745 51.4435 99.0412 50.0315 99.0878C48.5726 99.0777 47.4142 97.9068 47.4204 96.447Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2435 93.6682C66.7058 93.6744 67.8682 94.8468 67.862 96.3091C67.8557 97.7714 66.6834 98.9338 65.2211 98.9276C63.7614 98.9214 62.5961 97.7515 62.546 96.3426C62.609 94.8125 63.793 93.6621 65.2435 93.6682Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4244 93.6195C81.8864 93.6257 83.0531 94.7994 83.0997 96.2114C83.0896 97.6703 81.9187 98.8287 80.4589 98.8225C78.9968 98.8163 77.8302 97.6426 77.7835 96.2306C77.7937 94.7718 78.9645 93.6133 80.4244 93.6195Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0763 96.0758L93.0763 96.0684L93.0761 96.061C93.0342 94.6748 94.1894 93.5074 95.6603 93.5137C97.1248 93.5199 98.293 94.6977 98.3358 96.113C98.3777 97.4992 97.1656 98.7229 95.6947 98.7167C94.2324 98.7105 93.07 97.5381 93.0763 96.0758Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9569 79.0461C51.4192 79.0523 52.5816 80.2247 52.5754 81.687C52.5692 83.149 51.3956 84.3156 49.9836 84.3622C48.525 84.3521 47.3622 83.1801 47.3157 81.7705C47.3261 80.1884 48.507 79.0399 49.9569 79.0461Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3191 79.6719C64.3352 78.6455 65.991 78.6371 67.0173 79.6532C68.0437 80.6693 68.0521 82.3251 67.036 83.3515C66.0199 84.3779 64.3641 84.3862 63.3377 83.37C62.3113 82.3539 62.303 80.6983 63.3191 79.6719Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3722 78.892C81.8342 78.8983 83.0009 80.0718 83.0475 81.4839C83.0373 82.9427 81.8665 84.1012 80.4066 84.095C78.9446 84.0887 77.778 82.9152 77.7314 81.5031C77.7415 80.0443 78.9123 78.8858 80.3722 78.892Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9683 81.4056L92.9684 81.3983L92.9681 81.3909C92.9263 80.0047 94.0815 78.8373 95.5524 78.8435C97.0144 78.8498 98.1811 80.0234 98.2277 81.4354C98.2175 82.8943 97.0467 84.0527 95.5868 84.0465C94.1245 84.0403 92.9621 82.868 92.9683 81.4056Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.85 64.3763C51.3123 64.3825 52.4747 65.5548 52.4685 67.0172C52.4623 68.4792 51.2886 69.6459 49.8766 69.6925C48.418 69.6823 47.2552 68.5102 47.2087 67.1006C47.2191 65.5185 48.4001 64.3701 49.85 64.3763Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0856 64.2711C66.5476 64.2773 67.7143 65.4509 67.7609 66.863C67.7508 68.3215 66.5788 69.4843 65.1691 69.5308C63.7081 69.5207 62.5438 68.3448 62.5009 66.9321C62.4589 65.4212 63.6261 64.2649 65.0856 64.2711Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7383 66.8421L77.7383 66.8279L77.7374 66.8136C77.6479 65.3783 78.7975 64.2169 80.2658 64.2232C81.7278 64.2294 82.8945 65.403 82.9411 66.815C82.9309 68.2736 81.7589 69.4364 80.3493 69.4829C78.8904 69.4728 77.7321 68.302 77.7383 66.8421Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5022 64.117C96.9646 64.1233 98.1269 65.2956 98.1207 66.7579C98.1145 68.2203 96.9422 69.3826 95.4799 69.3764C94.0176 69.3701 92.8552 68.1978 92.8614 66.7355C92.8676 65.2731 94.0399 64.1108 95.5022 64.117Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7991 49.6489C51.2615 49.6552 52.4238 50.8275 52.4176 52.2898C52.4114 53.7522 51.2391 54.9145 49.7767 54.9083C48.3171 54.9021 47.1518 53.7322 47.1017 52.3233C47.1646 50.7932 48.3487 49.6428 49.7991 49.6489Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4507 52.2055L62.4509 52.2054L62.45 52.1917C62.3605 50.7567 63.5668 49.5386 65.0354 49.5449C66.4974 49.5511 67.664 50.7247 67.7106 52.1367C67.7005 53.5953 66.5284 54.7582 65.1188 54.8047C63.6577 54.7945 62.4934 53.6184 62.4507 52.2055Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6889 52.1157L77.6889 52.1015L77.6881 52.0872C77.5985 50.6519 78.7483 49.4905 80.2165 49.4968C81.6785 49.503 82.8452 50.6766 82.8918 52.0887C82.8817 53.5472 81.7096 54.7101 80.3 54.7566C78.8411 54.7464 77.6827 53.5756 77.6889 52.1157Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4525 49.3913C96.9149 49.3975 98.0773 50.5698 98.071 52.0322C98.0648 53.4942 96.8912 54.6609 95.4791 54.7075C94.0206 54.6973 92.8577 53.5253 92.8112 52.1156C92.8216 50.5335 94.0026 49.3851 95.4525 49.3913Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternDotsVertical);
export default __webpack_public_path__ + "static/media/pattern-dots-vertical.4244cb05f3c3f3148c758ac7e4d88ff7.svg";
export { ForwardRef as ReactComponent };